import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.19.17_babel-plug_0c4cbffdfd1585a6400afc8e0700ba04/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["StatsigExperimentContextProvider"] */ "/app/packages/statsig/src/StatsigExperimentContext.tsx");
